(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["blog-articles"] && !Shopify.designMode) return;
  try {
    (function () {
    function initNewsArticles(newsEl) {
      var newsBlogUrl = newsEl.getAttribute('data-np-news-blog-url');
      var initialNewsCount = Number(newsEl.getAttribute('data-np-initial-news-count') || 0);
      var showDate = newsEl.getAttribute('data-np-show-date') !== 'false';
      var showExcerpt = newsEl.getAttribute('data-np-show-excerpt') !== 'false';
      var sectionEl = newsEl.closest('[data-section-id]');
      var filters = sectionEl ? sectionEl.querySelector('[data-np-filters]') : null;
      // Fall back to a page-level filter container (e.g. a separate blog-hero section)
      if (!filters) filters = document.querySelector('[data-np-filters]');
      var resultsEl = newsEl.querySelector('[data-np-news-results]');
      var viewMoreContainer = newsEl.querySelector('[data-np-view-more-wrap="news"]');
      var viewMoreButton = viewMoreContainer ? viewMoreContainer.querySelector('button') : null;
      var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function parseParams() {
        var params = new URLSearchParams(window.location.search);
        var legacyTag = params.get('tag');
        var newsTag = params.get('news_tag') || legacyTag || '';
        return { newsTag: String(newsTag) };
      }

      function setParams(next, mode) {
        var url = new URL(window.location.href);
        var params = new URLSearchParams(url.search);

        if (next.newsTag) params.set('news_tag', next.newsTag);
        else params.delete('news_tag');

        params.delete('news_page');
        params.delete('tag');
        params.delete('page');

        var q = params.toString();
        url.search = q ? '?' + q : '';
        var state = { newsTag: next.newsTag };
        if (mode === 'replace') window.history.replaceState(state, '', url.toString());
        else window.history.pushState(state, '', url.toString());
      }

      function buildFetchUrl(tag, page) {
        if (!newsBlogUrl) return null;
        var base = tag
          ? newsBlogUrl + '/tagged/' + encodeURIComponent(tag)
          : newsBlogUrl;
        var url = new URL(base, window.location.origin);
        if (page && page > 1) url.searchParams.set('page', String(page));

        const news_feed_section_data=document.getElementById('news-feed-section-data');
        const section_id=news_feed_section_data.dataset.sectionId;
        //url.searchParams.set('section_id', 'news-feed');
        url.searchParams.set('section_id', section_id);
        return url.toString();
      }

      async function fetchFeed(url) {
        var res = await fetch(url, { headers: { Accept: 'text/html' } });
        if (!res.ok) throw new Error('Fetch failed: ' + res.status);
        var html = await res.text();
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var feedRoot = doc.querySelector('[data-np-feed-root]');
        if (feedRoot && !showDate) {
          feedRoot.querySelectorAll('.np-news-card__meta').forEach(function (el) { el.remove(); });
        }
        if (feedRoot && !showExcerpt) {
          feedRoot.querySelectorAll('.np-news-card__excerpt').forEach(function (el) { el.remove(); });
        }
        return feedRoot;
      }

      function maybeTrimFirstPage(feedRootEl) {
        if (!feedRootEl) return { hasMore: false };
        var limit = initialNewsCount;
        var page = Number(feedRootEl.getAttribute('data-np-page') || 1);
        if (!limit || page !== 1) {
          return { hasMore: feedRootEl.getAttribute('data-np-has-next') === 'true' };
        }
        var itemsEl = feedRootEl.querySelector('[data-np-feed-items]');
        if (!itemsEl) return { hasMore: feedRootEl.getAttribute('data-np-has-next') === 'true' };
        var children = Array.from(itemsEl.children);
        if (children.length <= limit) {
          return { hasMore: feedRootEl.getAttribute('data-np-has-next') === 'true' };
        }
        children.slice(limit).forEach(function (el) { el.remove(); });
        feedRootEl.setAttribute('data-np-has-next', 'true');
        return { hasMore: true };
      }

      function setLoading(isLoading) {
        if (!viewMoreContainer) return;
        var btn = viewMoreContainer.querySelector('button');
        if (!btn) return;
        var defaultLabel =
          viewMoreContainer.getAttribute('data-np-default-label') || btn.textContent || '';
        var loadingLabel =
          viewMoreContainer.getAttribute('data-np-loading-label') || defaultLabel;
        if (isLoading) {
          btn.textContent = loadingLabel;
          btn.setAttribute('disabled', 'disabled');
        } else {
          btn.textContent = defaultLabel;
        }
      }

      function updateViewMore(hasNext) {
        if (!viewMoreButton) return;
        viewMoreButton.toggleAttribute('disabled', !hasNext);
        viewMoreButton.classList.toggle('btn--disabled', !hasNext);
        viewMoreButton.setAttribute('aria-disabled', hasNext ? 'false' : 'true');

        if (hasNext) {
          viewMoreContainer.style.display = 'block';
        } else {
          viewMoreContainer.style.display = 'none';
        }
      }

      function setActiveFilter(tag) {
        if (!filters) return;
        filters.querySelectorAll('[data-np-tag]').forEach(function (btn) {
          var isActive = (btn.getAttribute('data-np-tag') || '') === (tag || '');
          btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      }

      async function replaceFeed(tag, page) {
        if (!resultsEl) return;
        resultsEl.setAttribute('aria-busy', 'true');
        setLoading(true);
        try {
          var url = buildFetchUrl(tag, page);
          if (!url) return;
          var newRoot = await fetchFeed(url);
          if (!newRoot) return;
          var trimResult = maybeTrimFirstPage(newRoot);
          var currentRoot = resultsEl.querySelector('[data-np-feed-root]');
          var doSwap = function () {
            if (currentRoot) currentRoot.replaceWith(newRoot);
          };
          if (!prefersReducedMotion && document.startViewTransition) {
            document.startViewTransition(doSwap);
          } else {
            doSwap();
          }
          updateViewMore(trimResult.hasMore);
        } finally {
          resultsEl.setAttribute('aria-busy', 'false');
          setLoading(false);
        }
      }

      async function appendNext(tag) {
        if (!resultsEl) return;
        var currentRoot = resultsEl.querySelector('[data-np-feed-root]');
        if (!currentRoot) return;
        var currentItems = currentRoot.querySelector('[data-np-feed-items]');
        if (!currentItems) return;
        var currentPage = Number(currentRoot.getAttribute('data-np-page') || 1);
        var currentCount = currentItems.children.length;

        resultsEl.setAttribute('aria-busy', 'true');
        setLoading(true);
        try {
          var fillUrl = buildFetchUrl(tag, currentPage);
          if (!fillUrl) return;
          var fillRoot = await fetchFeed(fillUrl);
          if (!fillRoot) return;
          var fillItems = fillRoot.querySelector('[data-np-feed-items]');
          if (!fillItems) return;
          var fillChildren = Array.from(fillItems.children);

          if (currentCount < fillChildren.length) {
            fillChildren.slice(currentCount).forEach(function (child) {
              child.classList.add('np-enter');
              currentItems.appendChild(child);
              requestAnimationFrame(function () { child.classList.remove('np-enter'); });
            });
            currentRoot.setAttribute(
              'data-np-pages',
              fillRoot.getAttribute('data-np-pages') || '1'
            );
            currentRoot.setAttribute(
              'data-np-has-next',
              fillRoot.getAttribute('data-np-has-next') || 'false'
            );
            updateViewMore(currentRoot.getAttribute('data-np-has-next') === 'true');
            return;
          }

          var nextPage = currentPage + 1;
          var nextUrl = buildFetchUrl(tag, nextPage);
          if (!nextUrl) return;
          var nextRoot = await fetchFeed(nextUrl);
          if (!nextRoot) return;
          var nextItems = nextRoot.querySelector('[data-np-feed-items]');
          if (!nextItems) return;

          Array.from(nextItems.children).forEach(function (child) {
            child.classList.add('np-enter');
            currentItems.appendChild(child);
            requestAnimationFrame(function () { child.classList.remove('np-enter'); });
          });

          currentRoot.setAttribute('data-np-page', String(nextPage));
          currentRoot.setAttribute(
            'data-np-pages',
            nextRoot.getAttribute('data-np-pages') || '1'
          );
          currentRoot.setAttribute(
            'data-np-has-next',
            nextRoot.getAttribute('data-np-has-next') || 'false'
          );

          var hasMore = currentRoot.getAttribute('data-np-has-next') === 'true';
          updateViewMore(hasMore);
        } finally {
          resultsEl.setAttribute('aria-busy', 'false');
          setLoading(false);
        }
      }

      function bind() {
        if (filters) {
          filters.addEventListener('click', async function (e) {
            var btn = e.target.closest('[data-np-tag]');
            if (!btn) return;
            var tag = btn.getAttribute('data-np-tag') || '';
            setActiveFilter(tag);
            setParams({ newsTag: tag }, 'push');
            await replaceFeed(tag, 1);
          });
        }

        if (viewMoreButton) {
          viewMoreButton.addEventListener('click', async function () {
            var state = parseParams();
            await appendNext(state.newsTag);
          });
        }

        window.addEventListener('popstate', async function () {
          var state = parseParams();
          setActiveFilter(state.newsTag);
          await replaceFeed(state.newsTag, 1);
        });
      }

      async function init() {
        var state = parseParams();
        setActiveFilter(state.newsTag);

        // Canonicalize legacy tag/page params
        var params = new URLSearchParams(window.location.search);
        if (params.get('tag') || params.get('page') || params.get('news_page')) {
          setParams(state, 'replace');
        }

        await replaceFeed(state.newsTag, 1);
        bind();
      }

      init().catch(function () {});
    }

    function run() {
      document.querySelectorAll('[data-np-news]').forEach(initNewsArticles);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["card-modal"] && !Shopify.designMode) return;
  try {
    // Lazy load images in modal content
  // Images have data-src instead of src (set by Liquid)
  // When modal opens, restore src to trigger loading
  (function () {
    document.querySelectorAll('.card-modal').forEach(function (modal) {
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.attributeName === 'open' && modal.hasAttribute('open')) {
            modal.querySelectorAll('[data-lazy-content] img[data-src]').forEach(function (img) {
              img.src = img.dataset.src;
              img.removeAttribute('data-src');
            });
          }
        });
      });
      observer.observe(modal, { attributes: true });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["localization-selector"] && !Shopify.designMode) return;
  try {
    (function () {
    var forms = document.querySelectorAll(
      '[id$="-form"].localization-form, [id$="-form"][class*="localization-form"]'
    );

    forms.forEach(function (form) {
      var button = form.querySelector('[class$="-button"]');
      var listId = button ? button.getAttribute('aria-controls') : null;
      var list = listId ? document.getElementById(listId) : null;
      var countryInput = form.querySelector('input[name="country_code"]');
      var languageInput = form.querySelector('input[name="language_code"]');

      if (!button || !list || !countryInput || !languageInput) return;

      var items = Array.from(list.querySelectorAll('[role="menuitem"]'));
      var closedClass = 'localization-list--closed';

      function openMenu() {
        button.setAttribute('aria-expanded', 'true');
        list.classList.remove(closedClass);
        var active = list.querySelector('[aria-current="true"]') || items[0];
        if (active) active.focus();
      }

      function closeMenu(restoreFocus) {
        button.setAttribute('aria-expanded', 'false');
        list.classList.add(closedClass);
        if (restoreFocus) button.focus();
      }

      function focusItem(index) {
        if (index >= 0 && index < items.length) {
          items[index].focus();
        }
      }

      /* Toggle menu on button click */
      button.addEventListener('click', function () {
        if (this.getAttribute('aria-expanded') === 'true') {
          closeMenu(true);
        } else {
          openMenu();
        }
      });

      /* Open menu on arrow keys from button */
      button.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          e.preventDefault();
          openMenu();
        }
      });

      /* Progressive enhancement: intercept link clicks to submit form with country+language */
      items.forEach(function (item) {
        item.addEventListener('click', function (e) {
          e.preventDefault();
          countryInput.value = this.getAttribute('data-country-code');
          languageInput.value = this.getAttribute('data-language-code');
          form.submit();
        });
      });

      /* Keyboard navigation within the menu */
      list.addEventListener('keydown', function (e) {
        var currentIndex = items.indexOf(document.activeElement);

        switch (e.key) {
          case 'ArrowDown':
            e.preventDefault();
            focusItem(currentIndex < items.length - 1 ? currentIndex + 1 : 0);
            break;
          case 'ArrowUp':
            e.preventDefault();
            focusItem(currentIndex > 0 ? currentIndex - 1 : items.length - 1);
            break;
          case 'Home':
            e.preventDefault();
            focusItem(0);
            break;
          case 'End':
            e.preventDefault();
            focusItem(items.length - 1);
            break;
          case 'Escape':
            e.preventDefault();
            closeMenu(true);
            break;
          case 'Tab':
            closeMenu(false);
            break;
        }
      });

      /* Close on outside click */
      document.addEventListener('click', function (event) {
        if (!form.contains(event.target)) {
          closeMenu(false);
        }
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["press-articles"] && !Shopify.designMode) return;
  try {
    (function () {
    function initPressArticles(pressEl) {
      var pressFeedUrl = pressEl.getAttribute('data-np-press-feed-url');
      var initialPressCount = Number(pressEl.getAttribute('data-np-initial-press-count') || 0);
      var sectionEl = pressEl.closest('[data-section-id]');
      var filters = sectionEl ? sectionEl.querySelector('[data-np-filters]') : null;
      // Fall back to a page-level filter container (e.g. a separate press-hero section)
      if (!filters) filters = document.querySelector('[data-np-filters]');
      var resultsEl = pressEl.querySelector('[data-np-press-results]');
      var viewMoreContainer = pressEl.querySelector('[data-np-view-more-wrap="press"]');
      var viewMoreButton = viewMoreContainer ? viewMoreContainer.querySelector('button') : null;
      var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function parseParams() {
        var params = new URLSearchParams(window.location.search);
        var pressTag = params.get('press_tag') || '';
        var pressPage = Number(params.get('press_page') || 1);
        pressPage = Number.isFinite(pressPage) && pressPage > 0 ? pressPage : 1;
        return { pressTag: String(pressTag), pressPage: pressPage };
      }

      function setParams(next, mode) {
        var url = new URL(window.location.href);
        var params = new URLSearchParams(url.search);

        if (next.pressTag) params.set('press_tag', next.pressTag);
        else params.delete('press_tag');

        if (next.pressPage > 1) params.set('press_page', String(next.pressPage));
        else params.delete('press_page');

        // Preserve news params from current URL
        var newsTag = params.get('news_tag') || '';
        var newsPage = Number(params.get('news_page') || 1);
        if (newsTag) params.set('news_tag', newsTag);
        else params.delete('news_tag');
        if (newsPage > 1) params.set('news_page', String(newsPage));
        else params.delete('news_page');

        var q = params.toString();
        url.search = q ? '?' + q : '';
        var state = { pressTag: next.pressTag, pressPage: next.pressPage };
        if (mode === 'replace') window.history.replaceState(state, '', url.toString());
        else window.history.pushState(state, '', url.toString());
      }

      function buildFetchUrl(tag, page) {
        if (!pressFeedUrl) return null;
        var base = tag
          ? pressFeedUrl + '/tagged/' + encodeURIComponent(tag)
          : pressFeedUrl;
        var url = new URL(base, window.location.origin);
        if (page && page > 1) url.searchParams.set('page', String(page));
        url.searchParams.set('section_id', 'press-feed');
        return url.toString();
      }

      async function fetchFeed(url) {
        var res = await fetch(url, { headers: { Accept: 'text/html' } });
        if (!res.ok) throw new Error('Fetch failed: ' + res.status);
        var html = await res.text();
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.querySelector('[data-np-feed-root]');
      }

      function maybeTrimFirstPage(feedRootEl) {
        if (!feedRootEl) return { hasMore: false };
        var limit = initialPressCount;
        var page = Number(feedRootEl.getAttribute('data-np-page') || 1);
        if (!limit || page !== 1) {
          return { hasMore: feedRootEl.getAttribute('data-np-has-next') === 'true' };
        }
        var itemsEl = feedRootEl.querySelector('[data-np-feed-items]');
        if (!itemsEl) return { hasMore: feedRootEl.getAttribute('data-np-has-next') === 'true' };
        var children = Array.from(itemsEl.children);
        if (children.length <= limit) {
          return { hasMore: feedRootEl.getAttribute('data-np-has-next') === 'true' };
        }
        children.slice(limit).forEach(function (el) { el.remove(); });
        feedRootEl.setAttribute('data-np-has-next', 'true');
        return { hasMore: true };
      }

      function setLoading(isLoading) {
        if (!viewMoreContainer) return;
        var btn = viewMoreContainer.querySelector('button');
        if (!btn) return;
        var defaultLabel =
          viewMoreContainer.getAttribute('data-np-default-label') || btn.textContent || '';
        var loadingLabel =
          viewMoreContainer.getAttribute('data-np-loading-label') || defaultLabel;
        if (isLoading) {
          btn.textContent = loadingLabel;
          btn.setAttribute('disabled', 'disabled');
        } else {
          btn.textContent = defaultLabel;
        }
      }

      function updateViewMore(hasNext) {
        if (!viewMoreButton) return;
        viewMoreButton.toggleAttribute('disabled', !hasNext);
        viewMoreButton.classList.toggle('btn--disabled', !hasNext);
        viewMoreButton.setAttribute('aria-disabled', hasNext ? 'false' : 'true');

        if (hasNext) {
          viewMoreContainer.style.display = 'block';
        } else {
          viewMoreContainer.style.display = 'none';
        }
      }

      function setActiveFilter(tag) {
        if (!filters) return;
        filters.querySelectorAll('[data-np-tag]').forEach(function (btn) {
          var isActive = (btn.getAttribute('data-np-tag') || '') === (tag || '');
          btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      }

      async function replaceFeed(tag, page) {
        if (!resultsEl) return;
        resultsEl.setAttribute('aria-busy', 'true');
        setLoading(true);
        var hasMore = false;
        try {
          var url = buildFetchUrl(tag, page);
          if (!url) return;
          var newRoot = await fetchFeed(url);
          if (!newRoot) return;
          var trimResult = maybeTrimFirstPage(newRoot);
          var currentRoot = resultsEl.querySelector('[data-np-feed-root]');
          var doSwap = function () {
            if (currentRoot) currentRoot.replaceWith(newRoot);
          };
          if (!prefersReducedMotion && document.startViewTransition) {
            document.startViewTransition(doSwap);
          } else {
            doSwap();
          }
          hasMore = trimResult.hasMore;
        } finally {
          resultsEl.setAttribute('aria-busy', 'false');
          setLoading(false);
          updateViewMore(hasMore);
        }
      }

      async function appendNext(tag) {
        if (!resultsEl) return;
        var currentRoot = resultsEl.querySelector('[data-np-feed-root]');
        if (!currentRoot) return;
        var currentItems = currentRoot.querySelector('[data-np-feed-items]');
        if (!currentItems) return;
        var currentPage = Number(currentRoot.getAttribute('data-np-page') || 1);
        var currentCount = currentItems.children.length;

        resultsEl.setAttribute('aria-busy', 'true');
        setLoading(true);
        var hasMore = currentRoot.getAttribute('data-np-has-next') === 'true';
        try {
          var fillUrl = buildFetchUrl(tag, currentPage);
          if (!fillUrl) return;
          var fillRoot = await fetchFeed(fillUrl);
          if (!fillRoot) return;
          var fillItems = fillRoot.querySelector('[data-np-feed-items]');
          if (!fillItems) return;
          var fillChildren = Array.from(fillItems.children);

          if (currentCount < fillChildren.length) {
            fillChildren.slice(currentCount).forEach(function (child) {
              child.classList.add('np-enter');
              currentItems.appendChild(child);
              requestAnimationFrame(function () { child.classList.remove('np-enter'); });
            });
            currentRoot.setAttribute(
              'data-np-pages',
              fillRoot.getAttribute('data-np-pages') || '1'
            );
            currentRoot.setAttribute(
              'data-np-has-next',
              fillRoot.getAttribute('data-np-has-next') || 'false'
            );
            hasMore = currentRoot.getAttribute('data-np-has-next') === 'true';
            return;
          }

          var nextPage = currentPage + 1;
          var nextUrl = buildFetchUrl(tag, nextPage);
          if (!nextUrl) return;
          var nextRoot = await fetchFeed(nextUrl);
          if (!nextRoot) return;
          var nextItems = nextRoot.querySelector('[data-np-feed-items]');
          if (!nextItems) return;

          Array.from(nextItems.children).forEach(function (child) {
            child.classList.add('np-enter');
            currentItems.appendChild(child);
            requestAnimationFrame(function () { child.classList.remove('np-enter'); });
          });

          currentRoot.setAttribute('data-np-page', String(nextPage));
          currentRoot.setAttribute(
            'data-np-pages',
            nextRoot.getAttribute('data-np-pages') || '1'
          );
          currentRoot.setAttribute(
            'data-np-has-next',
            nextRoot.getAttribute('data-np-has-next') || 'false'
          );

          hasMore = currentRoot.getAttribute('data-np-has-next') === 'true';
          setParams({ pressTag: tag || '', pressPage: nextPage }, 'replace');
        } finally {
          resultsEl.setAttribute('aria-busy', 'false');
          setLoading(false);
          updateViewMore(hasMore);
        }
      }

      function bind() {
        if (filters) {
          filters.addEventListener('click', async function (e) {
            var btn = e.target.closest('[data-np-tag]');
            if (!btn) return;
            var tag = btn.getAttribute('data-np-tag') || '';
            setActiveFilter(tag);
            setParams({ pressTag: tag, pressPage: 1 }, 'push');
            await replaceFeed(tag, 1);
          });
        }

        if (viewMoreButton) {
          viewMoreButton.addEventListener('click', async function () {
            var state = parseParams();
            await appendNext(state.pressTag);
          });
        }

        window.addEventListener('popstate', async function () {
          var state = parseParams();
          setActiveFilter(state.pressTag);
          await replaceFeed(state.pressTag, state.pressPage);
        });
      }

      async function init() {
        var state = parseParams();
        setActiveFilter(state.pressTag);
        await replaceFeed(state.pressTag, state.pressPage);
        bind();
      }

      init().catch(function () {});
    }

    function run() {
      document.querySelectorAll('[data-np-press]').forEach(initPressArticles);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
